import { useEffect } from 'react';
import { useAtomValue } from 'jotai';
import { WS_EVENTS } from '@twinden/shared';
import { openConversationIdAtom } from '../store';
import { onPushSubscribedChange, viewingPresence } from '../lib/pwa';
import { useWebSocket } from './useWebSocket';

/**
 * Tells the server whether Twinden is in front on this device and which chat
 * it's showing, so it doesn't notify about what you're already looking at:
 * no push for the open chat, and no ringing push to this device while the
 * app is in front (it rings by itself). It names this device's own push
 * subscription, so the person's other devices still ring (issue #27). Sent
 * on every change, after every reconnect, and when push is turned on or off.
 */
export function useViewingPresence() {
  const openConversationId = useAtomValue(openConversationIdAtom);
  const { sendMessage, connectionEpoch } = useWebSocket();

  useEffect(() => {
    const send = () =>
      sendMessage(WS_EVENTS.VIEWING, viewingPresence(openConversationId));
    send();
    document.addEventListener('visibilitychange', send);
    const stopListening = onPushSubscribedChange(send);
    return () => {
      document.removeEventListener('visibilitychange', send);
      stopListening();
    };
  }, [openConversationId, connectionEpoch, sendMessage]);
}
